import React from "react";
import Sebrae from "../assets/imgs/sebrae.png";

const BcxSectionD = () => {
  return (
    <section id="sectionD">
      <div className="container">
        <div className="header">
          <div className="titulo">
            <img src={Sebrae} alt="Logo da Sebrae" />
            <h2>
              Uma Parceria com <br />
              <strong>soluções para sua empresa</strong>
            </h2>
          </div>
          <div className="descricao">
            <p>
              O Sebrae está oferecendo 1 capacitação online GRATUITA aos
              interessados.
            </p>
            <p>
              Mesmo sem efetivação do crédito, você pode ter acesso a ferramenta
              que te ajuda a gerenciar melhor seus negócios.
            </p>
            <p>
              <strong>Aproveite essa oportunidade!</strong>
            </p>
          </div>
        </div>

        <div className="content">
          <div className="col">
            <h3>Eventos, Finanças – 24h</h3>
            <a
              className="btn"
              href="https://digital.sebraers.com.br/produtos/financas/curso/programa-cred-nova-santa-rita/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Programa Cred Nova Santa Rita
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BcxSectionD;
